import type { ApiResponse, PublicUser } from '@giftsay/types';

import { apiClient } from '../../../lib/axios.js';

export async function fetchMe(): Promise<PublicUser> {
  const { data } = await apiClient.get<ApiResponse<PublicUser>>('/auth/me');
  return data.data!;
}
